module.exports = __webpack_public_path__ + "static/img/new_bg_en.67273b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_bg_en.png
// module id = Aa6V
// module chunks = 1